import iconThemeColor from "../index";

const HomeIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8689 4.34779C12.8745 3.22981 11.1273 3.2298 10.1329 4.34779L4.26489 10.945C4.08869 11.1431 3.99836 11.4031 4.01378 11.6678L4.39105 18.1454C4.46805 19.4674 5.56257 20.5 6.88682 20.5H17.1134C18.4375 20.5 19.5319 19.4677 19.6092 18.1459L19.988 11.6679C20.0034 11.4032 19.9131 11.1431 19.7369 10.945L13.8689 4.34779ZM10.8801 5.01239C11.4768 4.3416 12.525 4.3416 13.1217 5.01239L18.9897 11.6096L18.6109 18.0876C18.5645 18.8806 17.9079 19.5 17.1134 19.5H14.5V15C14.5 14.1716 13.8284 13.5 13 13.5H11C10.1716 13.5 9.5 14.1716 9.5 15V19.5H6.88682C6.09227 19.5 5.43556 18.8804 5.38936 18.0872L5.01209 11.6096L10.8801 5.01239ZM10.5 19.5H13.5V15C13.5 14.7239 13.2761 14.5 13 14.5H11C10.7239 14.5 10.5 14.7239 10.5 15V19.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const WorkspaceIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 10.5C12.5 10.2239 12.2761 10 12 10C11.7239 10 11.5 10.2239 11.5 10.5V14.7929L10.3536 13.6464C10.1583 13.4512 9.84171 13.4512 9.64645 13.6464C9.45118 13.8417 9.45118 14.1583 9.64645 14.3536L11.6464 16.3536C11.8417 16.5488 12.1583 16.5488 12.3536 16.3536L14.3536 14.3536C14.5488 14.1583 14.5488 13.8417 14.3536 13.6464C14.1583 13.4512 13.8417 13.4512 13.6464 13.6464L12.5 14.7929V10.5Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 5.5C5.39543 5.5 4.5 6.39543 4.5 7.5V16.5C4.5 17.6046 5.39543 18.5 6.5 18.5H17.5C18.6046 18.5 19.5 17.6046 19.5 16.5V9.9C19.5 8.79543 18.6046 7.9 17.5 7.9H13.1183L10.5992 5.74074C10.4179 5.58539 10.1871 5.5 9.94837 5.5H6.5ZM5.5 7.5C5.5 6.94772 5.94772 6.5 6.5 6.5H9.94837L12.4675 8.65926C12.6487 8.81461 12.8796 8.9 13.1183 8.9H17.5C18.0523 8.9 18.5 9.34772 18.5 9.9V16.5C18.5 17.0523 18.0523 17.5 17.5 17.5H6.5C5.94772 17.5 5.5 17.0523 5.5 16.5V7.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const AnalyticsIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 7C6 6.72386 5.77614 6.5 5.5 6.5C5.22386 6.5 5 6.72386 5 7V19C5 19.2761 5.22386 19.5 5.5 19.5H19.5C19.7761 19.5 20 19.2761 20 19C20 18.7239 19.7761 18.5 19.5 18.5H6V7Z"
        fill={fillColor}
      />
      <path
        d="M9.75 12C9.75 11.5858 9.41421 11.25 9 11.25C8.58579 11.25 8.25 11.5858 8.25 12V17.5C8.25 17.9142 8.58579 18.25 9 18.25C9.41421 18.25 9.75 17.9142 9.75 17.5V12Z"
        fill={fillColor}
      />
      <path
        d="M13 8.25C13.4142 8.25 13.75 8.58579 13.75 9V17.5C13.75 17.9142 13.4142 18.25 13 18.25C12.5858 18.25 12.25 17.9142 12.25 17.5V9C12.25 8.58579 12.5858 8.25 13 8.25Z"
        fill={fillColor}
      />
      <path
        d="M17.75 15C17.75 14.5858 17.4142 14.25 17 14.25C16.5858 14.25 16.25 14.5858 16.25 15V17.5C16.25 17.9142 16.5858 18.25 17 18.25C17.4142 18.25 17.75 17.9142 17.75 17.5V15Z"
        fill={fillColor}
      />
    </svg>
  );
};

const AdministrationIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4.5C8.72386 4.5 8.5 4.72386 8.5 5V6.5H15.5V5C15.5 4.72386 15.2761 4.5 15 4.5H9ZM7.5 5V6.5H5C3.61929 6.5 2.5 7.61929 2.5 9V17C2.5 18.3807 3.61929 19.5 5 19.5H19C20.3807 19.5 21.5 18.3807 21.5 17V9C21.5 7.61929 20.3807 6.5 19 6.5H16.5V5C16.5 4.17157 15.8284 3.5 15 3.5H9C8.17157 3.5 7.5 4.17157 7.5 5ZM19 7.5C19.8284 7.5 20.5 8.17157 20.5 9V11C20.5 11.8284 19.8284 12.5 19 12.5H5C4.17157 12.5 3.5 11.8284 3.5 11V9C3.5 8.17157 4.17157 7.5 5 7.5H19ZM3.5 13.0002C3.91783 13.314 4.4372 13.5 5 13.5H10V14C10 14.8284 10.6716 15.5 11.5 15.5H12.5C13.3284 15.5 14 14.8284 14 14V13.5H19C19.5628 13.5 20.0822 13.314 20.5 13.0002V17C20.5 17.8284 19.8284 18.5 19 18.5H5C4.17157 18.5 3.5 17.8284 3.5 17V13.0002ZM13 13.5H11V14C11 14.2761 11.2239 14.5 11.5 14.5H12.5C12.7761 14.5 13 14.2761 13 14V13.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const HelpIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7709 14.1973C12.1201 14.1973 12.3953 13.9117 12.4582 13.5681C12.4779 13.4606 12.5029 13.3558 12.5332 13.2539C12.6198 12.9622 12.7884 12.7002 13.039 12.4678C13.3307 12.1943 13.6064 11.9072 13.8662 11.6064C14.1259 11.3057 14.3379 10.9844 14.5019 10.6426C14.6705 10.2962 14.7549 9.91797 14.7549 9.50781C14.7549 8.97461 14.6478 8.51432 14.4336 8.12695C14.2194 7.73503 13.9072 7.43424 13.497 7.22461C13.0914 7.01497 12.5993 6.91016 12.0205 6.91016C11.4964 6.91016 11.0224 7.00814 10.5986 7.2041C10.1748 7.40007 9.83753 7.68262 9.58688 8.05176C9.44881 8.25887 9.34804 8.48893 9.28456 8.74195C9.19868 9.08429 9.49355 9.37793 9.84651 9.37793C10.1916 9.37793 10.4455 9.08488 10.5937 8.77324C10.6223 8.71304 10.6559 8.65712 10.6943 8.60547C10.8401 8.40495 11.0315 8.25684 11.2685 8.16113C11.5055 8.06543 11.7562 8.01758 12.0205 8.01758C12.3395 8.01758 12.6061 8.0791 12.8203 8.20215C13.039 8.3252 13.2031 8.50065 13.3125 8.72852C13.4264 8.95638 13.4834 9.22754 13.4834 9.54199C13.4834 9.85189 13.4287 10.1185 13.3193 10.3418C13.2099 10.5605 13.0664 10.7656 12.8886 10.957C12.7155 11.1439 12.5241 11.3444 12.3144 11.5586C12.0273 11.8548 11.7972 12.1191 11.624 12.3516C11.4508 12.584 11.3255 12.8415 11.248 13.124C11.2144 13.2522 11.188 13.3974 11.1689 13.5596C11.1278 13.909 11.419 14.1973 11.7709 14.1973Z"
        fill={fillColor}
      />
      <path
        d="M11.2685 15.8447C11.1409 15.986 11.0771 16.1592 11.0771 16.3643C11.0771 16.5602 11.1409 16.7288 11.2685 16.8701C11.3961 17.0114 11.5807 17.082 11.8222 17.082C12.0683 17.082 12.2552 17.0114 12.3828 16.8701C12.5104 16.7288 12.5742 16.5602 12.5742 16.3643C12.5742 16.1592 12.5104 15.986 12.3828 15.8447C12.2552 15.7035 12.0683 15.6328 11.8222 15.6328C11.5807 15.6328 11.3961 15.7035 11.2685 15.8447Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ThemedHomeIcon = iconThemeColor(HomeIcon);
export const ThemedWorkspaceIcon = iconThemeColor(WorkspaceIcon);
export const ThemedAnalyticsIcon = iconThemeColor(AnalyticsIcon);
export const ThemedAdministrationIcon = iconThemeColor(AdministrationIcon);
export const ThemedHelpIcon = iconThemeColor(HelpIcon);
